import { ActionTypes } from 'redux/utils/List'

export default ActionTypes('ICD_CODE')